<template>
  <div ref="scrollWrapper" class="page-home bgf5">

    <iHeader />
    <van-sticky @scroll="onScroll">
      <iNav :search-record="!isFixed" />
    </van-sticky>
    <iClassify ref="iClassify" :active="1" all-active :box-shadow="false" />
    <iHomeAdCarousel v-if="true" ref="iHomeAdCarousel" />
    <iRightFixedBox />
    <div style="min-height: 600px;">
      <transition name="fade">
        <iLeftFixedBox v-if="isLeftShow&&leftStoreyData.length" :data="leftStoreyData" @change="changeStorey" />
      </transition>
      <Storey ref="Storey" />
    </div>
    <NewCustomerActivity />
    <iFooter />
  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iNav from '@/components/Nav'
import iClassify from '@/components/Classify'
import iHomeAdCarousel from './HomeAdCarousel'
import iFooter from '@/components/Footer'
import Storey from '@/views/storey/Storey'
import iRightFixedBox from '@/components/RightFixedBox'
import iLeftFixedBox from '@/components/LeftFixedBox'
import NewCustomerActivity from '@/components/NewCustomerActivity'
import { BaseMixin } from '@/mixins/BaseMixin'
export default {
  name: 'Home',
  components: {
    iHeader,
    iNav,
    iClassify,
    iHomeAdCarousel,
    iFooter,
    iRightFixedBox,
    iLeftFixedBox,
    Storey,
    NewCustomerActivity
  },
  mixins: [BaseMixin],
  data() {
    return {
      isFixed: false,
      isLeftShow: false,
      url: {
        getHomePages: '/api_basedata/HomePage/GetAdvertisementsNavigations?enumTerminal=1', // 根据不同客户获取客户导航和广告信息
        getStoreys: '/api_basedata/HomePage/GetStoreys?enumTerminalType=1', // 获取楼层信息
        getAdvertisementInfos: 'api_basedata/HomePage/GetAdvertisementInfos', // 获取指定位置广告
        getSlogan: '' // 获取slogan
      },
      leftStoreyData: []
    }
  },
  created() {
    // this.initStorey()
    this.getHomePageShowData()
    this.$nextTick(() => {
      this.$refs['Storey'].init()
    })
  },
  mounted() {
    this.updateCustomOtherInfo()
    // 绑定监听页面滑动方法
    // window.addEventListener('scroll', this.handleSearch)
  },
  methods: {
    // 获取首页展示数据 轮播图 广告图 分类导航
    async getHomePageShowData() {
      this.$hys.openLoading()
      this.isLoading = true
      const res = await this.getAction(`${this.url.getHomePages}`)
      this.$hys.clearLoading()
      this.isLoading = false
      // console.log('获取首页展示数据', res)
      if (res.IsSuccess) {
        if (this.$refs['iHomeAdCarousel']) { this.$refs['iHomeAdCarousel'].init(res.Data.RotationSeedingList) }
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 首页楼层
    // async initStorey() {
    //   this.$hys.openLoading()
    //   // this.isLoading = true;
    //   const res = await this.getAction(`${this.url.getStoreys}`)
    //   this.$hys.clearLoading()
    //   // this.isLoading = false;
    //   // console.log("获取楼层数据", res);
    //   if (res.IsSuccess) {
    //     this.leftStoreyData = res.Data
    //     if (this.$refs['Storey']) this.$refs['Storey'].init(res.Data)
    //   } else {
    //     this.$toast({ position: 'bottom', message: res.Msg })
    //   }
    // },
    updateCustomOtherInfo() {
      this.$hys.openLoading()
      // 更新用户信息
      this.getAction('/api_customers/Customer/GetCustomerOtherInfo', {
        id: this.$auth.getCustomerId()
      }).then(res => {
        this.$hys.clearLoading()
        if (res.IsSuccess) {
          this.$auth.setCustomerOtherInfo(res.Data)
        }
      })
    },
    onScroll(e) {
      this.isFixed = e.isFixed
      const sheight = this.$refs.scrollWrapper.offsetHeight
      console.log('this.wrapperHeight:' + sheight)
      this.isLeftShow = !!(e.scrollTop < (sheight - 1600) && e.scrollTop > 550)
      // this.isLeftShow = e.scrollTop > 550 ? true : false;
    },
    changeStorey(v) {
      if (this.$refs['Storey']) this.$refs['Storey'].scrollTo(v)
    }

  }
}
</script>

<style scoped>
  /* 可以设置不同的进入和离开动画 */

  /* 设置持续时间和动画函数 */
  .fade-enter-active {
    transition: all .1s ease;
  }

  .fade-leave-active {
    transition: all .1s cubic-bezier(0, 0, 0, 0);
  }

  .fade-enter,
  .fade-leave-to {
    transform: translateX(0);
    opacity: 0;
  }
</style>
